import { Link, Outlet } from 'react-router-dom'
import { useAuth } from '../auth/AuthProvider'
import { CookieBanner } from './CookieBanner'

export function Layout() {
  const { session, profile, signOut } = useAuth()

  return (
    <>
      <header className="masthead">
        <div className="masthead__inner">
          <Link to="/" className="wordmark">
            Majortipset
          </Link>

          {session ? (
            <nav className="masthead__nav">
              <Link to="/">Start</Link>
              <Link to="/maraton">Maraton</Link>
              <Link to="/gang">Gäng</Link>
              {profile?.role === 'admin' && <Link to="/admin">Admin</Link>}
              <Link className="masthead__user" to="/smeknamn">
                {profile?.display_name ?? session.user.email}
                {profile?.nickname && ` · ${profile.nickname}`}
                {profile?.role === 'admin' && ' · admin'}
                {profile?.role === 'rattare' && ' · rättare'}
              </Link>
              <button className="link" onClick={signOut}>
                Logga ut
              </button>
            </nav>
          ) : (
            <nav className="masthead__nav">
              <Link to="/tabell">Tabellen</Link>
              <Link to="/logga-in">Logga in</Link>
            </nav>
          )}
        </div>
      </header>

      <main>
        <Outlet />
      </main>

      <CookieBanner />
    </>
  )
}
